export const API_FIELDS_DATA_KEYS = {
  parentDobFieldKey: 'PARENT_DOB',
  parentFullNameFieldKey: 'PARENT_NAME',
  emailFieldKey: 'EMAIL',
  phoneFieldKey: 'PHONE',
  insuranceMemberIdFieldKey: 'INSURANCE_MEMBER_ID',
  insuranceProviderNpiFieldKey: 'INSURANCE_PROVIDER_NPI',
  insuranceServiceTypeFieldKey: 'INSURANCE_SERVICE_TYPE',
  insurancePayerIdFieldKey: 'INSURANCE_PAYER_ID',

  // Booking
  zip: 'ZIP_CODE',
  age: 'CHILD_AGE',
  isDiagnosed: 'ASD_DIAGNOSIS',
  insurance: 'INSURANCE',
  provider: 'INSURANCE_PAYER_ID',
  parentFirstName: 'PARENT_FIRST_NAME',
  parentLastName: 'PARENT_LAST_NAME',
  smsOptOut: 'SMS_OPTOUT',
  timeSlot: 'DATETIME',
  bookingType: 'BOOKING_TYPE',
  timeZoneOffset: 'TIMEZONE_OFFSET',
  timeZoneAbbreviation: 'TIME_ZONE_ABBREVIATION'
}

export const INSURANCE_PROVIDER_NPI_ID = '1356975494'
export const INSURANCE_SERVICE_TYPE_CODE = '30'
